define(['jquery', 'pricehelper', 'erv_popup'],
	function($, PriceHelper, ERVPopup) {
		var ERVPriceBreakdown = function() {
			var self = this;
			self.$ervBody = $('#erv-body');
			self.priceBreakdownData = {};
			self.priceHelper = new PriceHelper();
			self.popup = new ERVPopup();

			self.setPersonData = function (i, $field, $productBox) {
				self.priceBreakdownData.persons[i] = self.priceBreakdownData.persons[i] || {};

				var dataPerson = self.priceBreakdownData.persons[i],
					$visibleAddonContainer = $productBox.find('.addon-container:not(.hide)'),
					$persons = $visibleAddonContainer.find('[data-js="needs"].individual .person');

				if ($persons.length) {
					$persons.each(function (index) {
						var $person = $(this);

						if (i === index) {
							dataPerson.baseprice = Number($person.data('baseprice'));
							dataPerson.excess = Number($person.data('excess'));
						}
					});
				} else {
					dataPerson.baseprice = $visibleAddonContainer.data('basepriceinclmedical');
					dataPerson.excess = $visibleAddonContainer.data('excess');
				}

				if ($field === null || typeof ($field) === 'undefined' || $field.length === 0 || ($field.is('option') && Number($field.val()) === -1)) { return false; }

				dataPerson.extras = dataPerson.extras || [];

				var $parent = $field.parent(),
					isInput = $field.is('input'),
					name = isInput ? $parent.find('[data-js="addonname"]').text() : $parent.find('option:first').text() + ' ' + $field.data('cancellationvalue'),
					price = isInput ? Number($parent.find('label .more-details [data-currentprice]').data('currentprice')) : $field.data('price');

				dataPerson.extras.push({ id: $field.val(), name: name, price: price, excessprice: $field.data('addon-excess-price'), showMedical: $field.data('ismedical') === true ? !$field.parents('li').hasClass('hide') : true });
			};

			self.setPricesInPricebreakdown = function ($lightbox) {
				var currency = $lightbox.find('[data-js="currency"]').text(),
					$personContainer = $lightbox.find('.person'),
					totalPersons = 0;

				$personContainer.each(function (index) {
					var dataPerson = self.priceBreakdownData.persons[index],
						$person = $(this),
						$basePerson = $person.find('[data-js="personbaseprice"]'),
						$totalPerson = $person.find('[data-js="persontotalprice"]'),
						$extrasContainer = $person.find('.extras');

					if (typeof (dataPerson) !== 'undefined' && typeof (dataPerson.baseprice) !== 'undefined') {
						var	totalPerson = dataPerson.baseprice;
					
						totalPerson = self.priceHelper.setExcess(self.priceBreakdownData.hasExcess, self.priceBreakdownData.presetExcess, totalPerson, dataPerson.excess);
						$basePerson.text(totalPerson);

						if (typeof (dataPerson.extras) !== 'undefined') {
							var $ul = $('<ul></ul>');

							dataPerson.extras.forEach(function (extras) {
								if (extras.showMedical) {
									var $li = $('<li>' +
										extras.name +
										' (<span data-extras="' +
										extras.price +
										'">' +
										extras.price +
										'</span> ' +
										currency +
										')' +
										'</li>');
									$ul.append($li);
								} else {
									totalPerson = self.priceHelper.setExcess(self.priceBreakdownData.hasExcess, self.priceBreakdownData.presetExcess, totalPerson, extras.excessprice);
									$basePerson.text(totalPerson);
								}
							});

							$extrasContainer.empty();
							if ($ul.find('li').length === 0) {
								$extrasContainer.text('-');
							} else {
								$extrasContainer.append($ul);
							}

							$extrasContainer.find('[data-extras]').each(function() {
								totalPerson += Number($(this).data('extras'));
							});
						} else {
							$extrasContainer.each(function () {
								$(this).empty();
								$(this).text('-');
							});
						}

						$totalPerson.text(totalPerson);
						totalPersons += totalPerson;
					}
				});

				self.setTaxDiscountAndTotal($lightbox, totalPersons);
			}

			self.setTaxDiscountAndTotal = function ($lightbox, totalPersons) {
				var discount = self.priceBreakdownData.discount,
					tax = self.priceBreakdownData.tax,
					$lightboxTotal = $lightbox.find('[data-js="totalprice"]'),
					$lightboxTax = $lightbox.find('[data-js="tax"]'),
					$lightboxDiscount = $lightbox.find('[data-js="discount"]');

				if (discount > 0) {
					$lightboxDiscount.text(self.priceHelper.formatPrice(totalPersons * (discount * 0.01), true));
				}

				if (tax > 0) {
					$lightboxTax.text(self.priceHelper.formatPrice((totalPersons - discount) * (tax * 0.01), true));
				}

				$lightboxTotal.text(self.priceBreakdownData.totalPrice);
			}

			self.pullPriceFromProductBox = function ($productBox, $lightbox) {
				var $addonsContainer = $productBox.find('.addon-container:not(.hide)'),
					$selectedFields = $addonsContainer.find('input[type="checkbox"]:checked:not([disabled]), select:not([disabled]) option:selected'),
					$excessContainer = $productBox.find('.excess-container'),
					$needs = $productBox.find('[data-js="needs"]'),
					insuranceTypeExists = $productBox.find('.insurance-type.field').length > 0,
					needsLimit = insuranceTypeExists ? 2 : 1;

				self.priceBreakdownData.totalPrice = $productBox.find('.price [data-oldprice]').text();
				self.priceBreakdownData.tax = Number($productBox.data('tax-pct'));
				self.priceBreakdownData.discount = Number($productBox.find('[data-js="discount-rate"]').text());
				self.priceBreakdownData.presetExcess = self.priceHelper.hasPresetExcess($excessContainer);
				self.priceBreakdownData.hasExcess = self.priceHelper.hasExcess($excessContainer);
				self.priceBreakdownData.persons = [];

				if ($needs.length > needsLimit) {
					if ($selectedFields.length > 0) {
						$selectedFields.each(function () {
							var $field = $(this),
								$individualContainer = $field.parents('div[data-js="needs"].individual:not(.hide)');

							if ($individualContainer.length) {
								self.setPersonData($field.closest('.person').prevAll().length, $field, $productBox);
							} else {
								var $hiddenIndividualContainer = $(this).parents('div[data-js="needs"]').parent().find('.individual.hide');

								$hiddenIndividualContainer.find('.person').each(function () {
									var $person = $(this);

									self.setPersonData($person.prevAll().length,
										$field.is('input')
										? $person.find('[value="' + $field.val() + '"]')
										: $person.find('option[value="' + $field.val() + '"]'),
										$productBox);
								});
							}
						});
					} else {
						$productBox.find('.addon-container:not(.hide) [data-js="needs"].individual .person').each(function () {
							self.setPersonData($(this).prevAll().length, null, $productBox);
						});
					}
				} else if ($needs.length === needsLimit) {
					if ($selectedFields.length > 0) {
						$selectedFields.each(function () {
							self.setPersonData(0, $(this), $productBox);
						});
					} else {
						self.setPersonData(0, null, $productBox);
					}
				}

				self.setPricesInPricebreakdown($lightbox);
			}

			self.initPriceBreakdown = function($parent) {
				var selector = "price-breakdown-lightbox";

				if (typeof ($parent) !== 'undefined') {
					selector = $parent.find('[id^="' + selector + '"]').attr('id');
				}

				var $lightbox = $('body').find('#' + selector);

				if (!$lightbox || !$lightbox.length) {
					return;
				}

				if ($parent.hasClass('booking')) {
					self.pullPriceFromProductBox($parent, $lightbox);
				}

				self.popup.openPopup(
					'#' + selector,
					{
						elementParse: function (item) {
							$(item.src).removeClass('hide');
						}
					},
					true,
					false
				);
			}
		};

		ERVPriceBreakdown.prototype.init = function() {
			var self = this;

			$(document).on('click', '.price-breakdown', function (e) {
				e.preventDefault();
				e.stopPropagation();

				self.initPriceBreakdown($(this).closest('.box'));
			});
		}

	return ERVPriceBreakdown;
});